import {SelectOptionView} from "../../data/View/SelectOptionView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";

export const CRMStatusModelAPI = {
    /**
     * Fetches all CRM statuses.
     * @returns {Promise<SelectOptionView[]>} Promise resolving to an array of SelectOptionView.
     */
    getCRMStatus: async (): Promise<SelectOptionView[]> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_CRM_STATUS_READ, {});
        return response.data;
    }
};
